import router from "@/router";
import store from "@/store";
import getUserInfo from "@/models/userInfo";
// import { Toast } from 'vant'

const blackPath = [
  "CustomerSearch",
  "CustomerDetail",
  "AppointmentHome",
  "AppointmentConfirm",
  "AppointmentHistory",
  "AppointmentDoctor",
  "BookingHome",
  "BookingHome",
  "ReserveCalendar",
  "AiChat",
];

router.beforeEach(async (to, from, next) => {
  document.title = to.meta?.title || "圆和健康";
  if (blackPath.indexOf(to.name) !== -1) {
    const userInfo = await getUserInfo();
    if (userInfo && userInfo.user_id) {
      store.dispatch("user/setUserInfo", userInfo);
      next();
    } else {
      next({
        name: "SystemLogin",
        params: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});
